/**
 * QBank Config Boot File
 *
 * Runs FIRST in the boot sequence to fetch runtime config from the API.
 * All subsequent boot files (sentry, axios) can then read the config synchronously.
 *
 * IMPORTANT: Safari 12 / iOS 12 compatible.
 */
import { boot } from "quasar/wrappers";

var qbankConfig = require('../config/qbank.js');

export default boot(function () {
  return qbankConfig.fetchConfig();
});
